export const initialTestimonials = [
  {
    id: 1,
    name: "María González",
    childName: "Sofía, 6 años",
    rating: 5,
    comment: "El Centro Volantín ha sido fundamental en el desarrollo de mi hija. El equipo es muy profesional y cercano. Sofía ha mejorado mucho en su comunicación.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Carlos Mendoza",
    childName: "Lucas, 8 años",
    rating: 5,
    comment: "Excelente atención y resultados. Lucas ha desarrollado habilidades que nunca pensamos que lograría. El ambiente es muy acogedor para los niños.",
    date: "2024-01-10"
  },
  {
    id: 3,
    name: "Ana Silva",
    childName: "Emma, 5 años",
    rating: 5,
    comment: "La terapia ocupacional ha sido increíble para Emma. Ha mejorado su coordinación y autonomía. El equipo es muy dedicado y profesional.",
    date: "2024-01-08"
  },
  // {
  //   id: 4,
  //   name: "Roberto Vega",
  //   childName: "Diego, 7 años",
  //   rating: 5,
  //   comment: "El apoyo psicológico ha sido fundamental para Diego. Ha aprendido a manejar mejor sus emociones y su autoestima ha mejorado notablemente.",
  //   date: "2024-01-05"
  // },
  // {
  //   id: 5,
  //   name: "Laura Torres",
  //   childName: "Valentina, 9 años",
  //   rating: 5,
  //   comment: "La psicopedagoga ha ayudado mucho a Valentina con sus dificultades de aprendizaje. Ahora está más confiada y motivada en el colegio.",
  //   date: "2024-01-03"
  // }
];
